import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, KineticHeadingInView } from "@/components/common/Reveal";

export default function CTASection({
  overline = "Ready when you are",
  heading = ["Let's put technology to work", "for your growth agenda."],
  body = "Book a confidential session. No pitch, a candid conversation about where you are and where you want to be.",
  primary = { label: "Book Executive Strategy Session", to: "/book" },
  secondary = { label: "Explore Advisory Services", to: "/services/executive-advisory" },
}) {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-surface py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/2 h-[500px] w-[500px] -translate-y-1/2 translate-x-1/3 rounded-full bg-sky/10 blur-3xl" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="font-body text-xs font-bold uppercase tracking-[0.25em] text-royal">{overline}</p>
            <h2 className="mt-6 font-heading text-4xl font-light leading-[1.02] tracking-tight text-navy md:text-6xl">
              <KineticHeadingInView lines={heading} />
            </h2>
            <p className="mt-6 max-w-xl font-body text-lg leading-relaxed text-slate-600">{body}</p>
          </div>
          <div className="lg:col-span-5 lg:flex lg:flex-col lg:items-end lg:justify-center">
            <Reveal className="flex flex-col items-start gap-4 sm:flex-row lg:flex-col lg:items-end">
              <Link
                to={primary.to}
                data-testid="cta-section-book"
                className="group inline-flex items-center gap-3 rounded-full bg-royal px-8 py-4 font-body text-base font-semibold text-white transition-colors duration-300 hover:bg-navy"
              >
                {primary.label}
                <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
              {secondary && (
                <Link
                  to={secondary.to}
                  data-testid="cta-section-secondary"
                  className="inline-flex items-center gap-2 rounded-full border border-slate-300 px-8 py-4 font-body text-base font-medium text-navy transition-colors hover:border-royal hover:text-royal"
                >
                  {secondary.label}
                </Link>
              )}
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
